import { faInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { default as Textarea } from 'react-textarea-autosize';
import { InputStyled, Grid, SeeMoreLessBlock, SeeMoreLessSize, BodyText, Button, Header4Text } from 'ui-toolkit';
import { RequirementExceptionPopup } from './RequirementExceptionPopup';
import { PopupContainer, SortableListRowAlignRight } from './RequirementExceptionRow.styles';
import { Tag } from '@zillow/constellation';
import styled from 'styled-components';

// TODO once apps are combined, move this to a better location (out of components)

interface IRequirementExceptionRow {
  code?: string;
  content: string;
  info?: string;
  infoTitle?: string;
  onTextChanged: (newText: string) => void;
}

const StyledTextArea = styled(InputStyled.withComponent(Textarea))`
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 60px;
`;

export const RequirementExceptionRow: React.FC<IRequirementExceptionRow> = ({
  code,
  content,
  info,
  infoTitle,
  onTextChanged,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState(content);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (content !== inputValue) {
      setInputValue(content);
    }
  }, [content, inputValue]);

  const toggleInput = () => {
    setShowInput(!showInput);
  };

  const onInputChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.persist();
    setInputValue(e.target.value);
  };

  const onInputBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    toggleInput();
    onTextChanged(e.target.value);
  };
  const onTextAreaFocus = (ref: any) => {
    if (ref) {
      ref.focus();
    }
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <Grid templateColumns={code ? 'auto 1fr min-content' : '1fr min-content'}>
      {code && <Tag>{code}</Tag>}
      <SeeMoreLessBlock maxHeight={SeeMoreLessSize.regular}>
        {showInput ? (
          <StyledTextArea
            defaultValue={inputValue}
            inputRef={onTextAreaFocus}
            onBlur={onInputBlur}
            onChange={onInputChanged}
          />
        ) : (
          <BodyText onClick={toggleInput}>{content}</BodyText>
        )}
      </SeeMoreLessBlock>
      <SortableListRowAlignRight>
        {info ? (
          <PopupContainer>
            <Button intent="ghost" isInline onMouseEnter={togglePopup} onMouseLeave={togglePopup} onClick={togglePopup}>
              <FontAwesomeIcon icon={faInfo} />
            </Button>
            {showPopup ? (
              <RequirementExceptionPopup>
                <Header4Text>{infoTitle}</Header4Text>
                <BodyText>{info}</BodyText>
              </RequirementExceptionPopup>
            ) : null}
          </PopupContainer>
        ) : null}
      </SortableListRowAlignRight>
    </Grid>
  );
};
